import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";
import qs from "qs";
const GroupPhotoService = {};

GroupPhotoService.getPosePackages = function (params) {
  return fetch({
    url: ApiConstant.GROUP_PHOTO_PACKAGES_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
GroupPhotoService.getGroupPhotos = function (params) {
  return fetch({
    url: ApiConstant.GROUP_PHOTO_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

GroupPhotoService.downalodGroupPhotosExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.GROUP_PHOTO__EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};

GroupPhotoService.getSingleGroupPhoto = function (params) {
  return fetch({
    url: ApiConstant.GROUP_PHOTO_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

GroupPhotoService.addGroupPhoto = function (data, params) {
  // const formData = Utils.toFormData(data);
  return fetch({
    url: ApiConstant.GROUP_PHOTO_CREATE,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};

GroupPhotoService.editGroupPhoto = function (data, params) {
  // const formData = Utils.toFormData(data);
  return fetch({
    url: ApiConstant.GROUP_PHOTO_UPDATE,
    method: "PUT",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
GroupPhotoService.editGroupPhotoType = function (data, params) {
  const payload = {
    status: data.status,
    group_photo_type_ids: [params.group_photo_type_id],
  };
  return fetch({
    url: ApiConstant.GROUP_PHOTO_TYPE_UPDATE_STATUS,
    method: "PUT",
    data: payload,
    params: Utils.filterHeaderParams(params),
  });
};

GroupPhotoService.addGroupPhotoType = function (data, params) {
  return fetch({
    url: ApiConstant.GROUP_PHOTO_TYPE_CREATE,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};

GroupPhotoService.getGroupPhotoType = function (params) {
  return fetch({
    url: ApiConstant.GROUP_PHOTO_TYPE_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
     paramsSerializer: (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      }),
  });
};
GroupPhotoService.deleteGroupPhoto = function (data) {
  return fetch({
    url: ApiConstant.GROUP_PHOTO_DELETE,
    method: "delete",
    data: data,
  });
};

GroupPhotoService.editGroupStatus = function (data, status) {
  const payload = {
    status: status,
    group_photos_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.GROUP_PHOTO_UPDATE_STATUS,
    method: "PUT",
    data: payload,
  });
};
GroupPhotoService.editGroupTypeStatus = function (data, status) {
  const payload = {
    status: status,
    group_photo_type_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.GROUP_PHOTO_TYPE_UPDATE_STATUS,
    method: "PUT",
    data: payload,
  });
};

export default GroupPhotoService;
